import type { IEaWasteReturnListSourceRow } from "./listSourceMappingAdapter";
import type { IEaWasteReturnFieldRow } from "./wasteReturnFieldMappingAdapter";

function isKnownSheet(sheet: string, sheetOptions: string[]): boolean {
    const trimmed = sheet.trim();
    return trimmed.length > 0 && sheetOptions.includes(trimmed);
}

function normalizeSheetRow<T extends { sheet: string; address: string }>(
    row: T,
    sheetOptions: string[]
): T {
    const trimmedSheet = row.sheet.trim();
    if (sheetOptions.length === 0 || !trimmedSheet || isKnownSheet(trimmedSheet, sheetOptions)) {
        return row;
    }

    return {
        ...row,
        sheet: sheetOptions[0],
        address: "",
    };
}

export function normalizeFieldRowsForSheetOptions(
    rows: IEaWasteReturnFieldRow[],
    sheetOptions: string[]
): IEaWasteReturnFieldRow[] {
    if (sheetOptions.length === 0) {
        return rows;
    }

    return rows.map((row) => normalizeSheetRow(row, sheetOptions));
}

export function normalizeListSourceRowsForSheetOptions(
    rows: IEaWasteReturnListSourceRow[],
    sheetOptions: string[]
): IEaWasteReturnListSourceRow[] {
    if (sheetOptions.length === 0) {
        return rows;
    }

    return rows.map((row) => normalizeSheetRow(row, sheetOptions));
}

export function normalizeMappingRowsForSheetOptions(
    fieldRows: IEaWasteReturnFieldRow[],
    listSourceRows: IEaWasteReturnListSourceRow[],
    sheetOptions: string[]
): { fieldRows: IEaWasteReturnFieldRow[]; listSourceRows: IEaWasteReturnListSourceRow[] } {
    return {
        fieldRows: normalizeFieldRowsForSheetOptions(fieldRows, sheetOptions),
        listSourceRows: normalizeListSourceRowsForSheetOptions(listSourceRows, sheetOptions),
    };
}
